var React = require('react');
var PropTypes = React.PropTypes;
var CollectionRes = require('../../../resources/collection');
var ConceptRes = require('../../../resources/concept');
var Auth = require('../../../resources/auth');
import CollectionCommentList from '../Review/CollectionCommentList';
import QuestionContent from '../../QuestionContent/QuestionContent';
import QuestionContainer from '../../CollectionEditor/QuestionContainer';
import EditorStep1 from '../../CollectionEditor/EditorStep1';
import ReviewQuestion from '../Review/ReviewQuestion';
import Helpers from '../../../utils/helpers';
import RaisedButton from 'material-ui/RaisedButton';
var $ = require('jquery');
var request = require('superagent');
var env = require('../../../utils/env');
var apiDomain = env.domain.api;
import { browserHistory } from 'react-router';
import notification from '../../Modal/notification';
import createConfirm from '../../Modal/createConfirm';
import ReactDOM from 'react-dom';
import createNotificationDialog from '../../Modal/createNotificationDialog';


var steps = [{
  title: "Select Concept"
}, {
  title: "Add Questions"
}, {
  title: "Preview & Submit"
}];

var ReviseCollection = React.createClass({

  navigateStep: function(step) {
    // Disable changing step from clicking 3 labels
    // return;
    if (this.state.currentStepIndex !== steps.indexOf(step)) {
      this.setState({
        currentStepIndex: steps.indexOf(step)
      });
    }
  },

  stepChangeHandle: function(value) {
    this.setState({
      currentStepIndex: value
    })
  },

  retrieveCollectionWithTask: function(callback) {
    callback = callback || function(){};
    var _this = this;
    var collectionId = this.props.params.collectionId;
    var options = {
      query: {"include": "review_task"},
      collectionId: collectionId
    }
    CollectionRes.retrieveSingleCollection(options, function(err, res) {
      if (!err && res) {
        var reviewTaskData = _this.transformCollectionData2TaskData(res);
        _this.setState({
          isLoading: false,
          reviewTaskData: reviewTaskData,
          collection: res
        }, function() {
          return callback();
        })
      } else {
        _this.setState({
          isLoading: false
        }, function() {
          return callback();
        })
      }
    })
  },

  retrieveAllConcepts: function(callback) {
    var _this = this;
    callback = callback || function(){};
    ConceptRes.retrieveUserCourses(function(err, courses) {
      if (err) return;
      var courseCount = courses.length;
      var conceptsArr = [];
      for (var i = 0; i < courses.length; i++) {
        ConceptRes.retrieveConceptTree(courses[i].metadata.concepts[0], function(err2, res) {
          if (err2) return;
          conceptsArr = conceptsArr.concat(res);
          courseCount--;
          if (courseCount <= 0) {
            var conceptObj = {children: conceptsArr};
            var builtData = _this.buildInitialConceptData(conceptObj);
            _this.setState({
              concepts: conceptObj,
              conceptMap: builtData.map
            }, function() {
              callback();
            })
          }
        })
      }
    })
  },

  buildInitialConceptData: function(concept, result) {
    result = result || {};
    result.map = result.map || {};
    result.leaf = result.leaf || {};
    if (concept._id) result.map[concept._id] = concept;
    if (concept.children.length > 0) {
      concept.activeChildren = concept.children[0];
      for (var i = 0; i < concept.children.length; i++) {
        this.buildInitialConceptData(concept.children[i], result);
      }
    } else {
      result.leaf[concept._id] = concept;
    }
    return result;
  },

  transformCollectionData2TaskData: function(collectionData) {
    var result = {
      contentInfo: collectionData
    }
    return result;
  },

  retrieveConceptsMap: function(reviewData, callback) {
    callback = callback || function(){};
    reviewData = reviewData || this.state.reviewTaskData;
    var _this = this;
    ConceptRes.retrieveAllConceptsLeafMap(function(err, conceptsMap) {
      if (err) return;
      reviewData.contentInfo = ConceptRes.buildConceptToCollectionData(reviewData.contentInfo, conceptsMap);
      // State: reviewData.contentInfo === collection (so do not need to update state.collection)
      _this.setState({
        reviewTaskData: reviewData,
        isLoading: false,
        conceptsMap: conceptsMap
      }, function() {
        return callback();
      })
    })
  },

  newQuestion: function() {
    return ({
      kquestion: {
        description: "",
        diffLevel: 0.25,
        type: 11,
        concepts: [],
        solution: [],
        textInputAnswers: [],
        selectionChoices: [{
          text: "",
          image: "",
          answerValue: 0
        },{
          text: "",
          image: "",
          answerValue: 0
        },{
          text: "",
          image: "",
          answerValue: 0
        },{
          text: "",
          image: "",
          answerValue: 0
        }]
      }
    })
  },

  addQuestion: function() {
    var collection = this.state.collection;
    collection.questions.push(this.newQuestion());
    this.setState({
      collection: collection
    })
  },

  updateSubject: function(subject) {
    this.setState({
      subject: subject
    })
    console.log('-------------------Change subject------------', subject)
    if(subject !== 'a234e6f6-a3ee-4bfe-9143-5c52f89ac84c'){
      var collection = this.state.collection;
      console.log("--------------------Collection-------------")
      for (var i = 0; i < collection.questions.length; i++) {
        if (collection.questions[i].kquestion.type !== 22) continue;
        for (var j = 0; j < collection.questions[i].kquestion.textInputAnswers.length; j++) {
          delete collection.questions[i].kquestion.textInputAnswers[j].preText;
          delete collection.questions[i].kquestion.textInputAnswers[j].postText;
          collection.questions[i].kquestion.textInputAnswers[j].text = '';
          collection.questions[i].kquestion.textInputAnswers[j].type = 'MANUAL_MARKING';
        }
        this.setState({
          collection
        })
      }
    }
  },

  removeQuestion: function(question){
    var _state = this.state;
    var _this = this;
    var questions = this.state.collection.questions;
    questions.splice(questions.indexOf(question), 1);
    if (question.kquestion._id) {
      request.delete(apiDomain + '/v1/kquizzes/' + this.state.collection._id + '/kquestions/' + question.kquestion._id)
      .withCredentials()
      .then(function(response) {
        // _this.setState(_state);
      }, function(err) {
        // Handle err case here
      })
    }
    this.setState(_state);
  },

  submitCollection: function() {
    var collection = this.state.collection;
    collection.status = 'to_be_reviewed';
    this.saveCollection(function(err, res) {
      if (err) {
        notification.open({
          message: 'Error',
          description: "Cannot submit collection for reviewing. Please try again"
        })
      } else {
        notification.open({
          message: 'Success',
          description: "Collection has beed submitted for reviewing!"
        });
        browserHistory.push('/collections');
      }
    });
  },

  discardCollection: function() {
    this.setState({openConfirm: true});
    this.confirmable = createConfirm({
      title: 'CONFIRM',
      content: 'Are you sure to discard changes you made. This cannot be undone!'
    }, () => {
      this.setState({openConfirm: false });
      // Admin -> navigate back to Completed tab
      // Teacher -> navigate back to Need Revision tab
      if (Auth.getCurrentUser().role === 'admin') return browserHistory.push("/collections?mode=completed");
      else return browserHistory.push("/collections?mode=need-revision");
    }, () => {
      this.setState({openConfirm: false });
    })
  },

  validateLongQuestionData: function(){
    var result = {
      isValid: true,
      invalidSumMarkQuestionIndex: -1
    }
    var collection = this.state.collection;
    console.log("--------------------Collection-------------")
    console.log("collection ",collection)
    for (var i = 0; i < collection.questions.length; i++) {
      if (collection.questions[i].kquestion.type !== 22) continue;
      var kquestion = collection.questions[i].kquestion;
      var sum = 0, questionMark = kquestion.score;
      for (var j = 0; j < kquestion.textInputAnswers.length; j++) {
        sum += kquestion.textInputAnswers[j].answerValue;
      }

      // if total points of each part does not equal point of this long question, return invalid
      if (sum !== questionMark) { 
        result.isValid = false;
        result.invalidSumMarkQuestionIndex = i;
      }
    }
    return result;
  },

  saveCollection: function(callback) {
    // callback = callback || function(){};
    var longQValidation = this.validateLongQuestionData();
    if (!longQValidation.isValid) {
      return notification.open({
        message: 'Cannot Save',
        description: 'Question ' + (longQValidation.invalidSumMarkQuestionIndex+1) + ': sum of part\'s mark should be equal to question\'s mark'
      })
    }
    $("body, html").addClass("heavy-load");
  
    var _this = this;
    var collection = this.state.collection;
    // If concepts had changes (EditorStep1 got rendered), we need to update concepts for each question
    // Otherwise, remain old concepts
    if (this.state.concepts) {
      var updatedConcept = this.getChosenConcept();
      console.log(updatedConcept)
      var subject = Helpers.getSubject(this.state.conceptsMap, updatedConcept._id);
      if (!collection.metadata) collection.metadata = {};
      collection.metadata.subjectName = subject.title;
      collection.metadata.conceptName = this.state.conceptsMap[updatedConcept._id].title;
      collection.concepts = [updatedConcept._id];
      for (var i = 0; i < collection.questions.length; i++) {
        collection.questions[i].kquestion.concepts = [updatedConcept._id];
      }
      if(this.state.concepts.activeChildren && this.state.concepts.activeChildren.title === 'Science') {
        console.log('go here')
        for (var j = 0; j < collection.questions.length; j++) {
          if(collection.questions[j].kquestion.type === 22 && collection.questions[j].kquestion.textInputAnswers){
            for (var k = 0; k < collection.questions[j].kquestion.textInputAnswers.length; k++) {
              delete collection.questions[j].kquestion.textInputAnswers[k].preText;
              delete collection.questions[j].kquestion.textInputAnswers[k].postText;
              delete collection.questions[j].kquestion.textInputAnswers[k].text;
              collection.questions[j].kquestion.textInputAnswers[k].type = 'MANUAL_MARKING';       
            }
          }
        }
        console.log(collection.questions)
      }
    }
    
    CollectionRes.saveCollection(collection, function(err, res) {
      $("body, html").removeClass("heavy-load");
      if (callback) return callback(err, res);
      if (!err && res) {
        // alert("Save collection success");
        notification.open({
          message: 'Success',
          description: 'Collection has been saved successfully.'
        })
        // return callback(err, res);
      } else {
        return notification.open({
          message: 'Error',
          description: 'Cannot save collection. Please try again'
        })
        // return alert("Cannot submit collection. Please try again");
      }
    })
  },

  getChosenConcept: function(conceptObj) {
    if (!conceptObj) return this.getChosenConcept(this.state.concepts);
    else {
      if (conceptObj.activeChildren) return this.getChosenConcept(conceptObj.activeChildren);
      else return conceptObj;
    }
  },

  updateConceptChange: function(concept) {
    // return;
    var newUpdatedConcept = this.getChosenConcept(concept);
    this.bindConceptToQuestion(newUpdatedConcept);
  },
  bindConceptToQuestion: function(newConcept) {
    var collection = this.state.collection;
    for (var i = 0; i < collection.questions.length; i++) {
      var kquestion = collection.questions[i].kquestion;
      kquestion.concepts = [newConcept._id];
    }
    this.setState({
      collection: collection
    })
  },

  rebuildConceptData: function(conceptId, result) {
    result = result || {};
    var conceptMapping = this.state.conceptMap;
    var concept = conceptMapping[conceptId];
    result = concept;
    console.log('upper',conceptMapping['d1817781-ab49-4517-b8e6-b6f56f38211d'])
    if (concept && concept.upperConcept && conceptMapping[concept.upperConcept]) {
      if (conceptMapping[concept.upperConcept]) {
        result = concept;
        conceptMapping[concept.upperConcept].activeChildren = concept;
      }
      // activeArr.push(concept);
      return this.rebuildConceptData(concept.upperConcept, result);
    }
    return result;
  },
  updateConceptLeafMapping: function(){

  },

  updateConcepts: function(concepts){
    this.setState({concepts: concepts});
  },

  renderHeaderActionBaseOnStep: function() {
    var step = this.state.currentStepIndex,
        collection = this.state.collection;
    if (step === 0) return null;
    else if (step === 1) return (
      <div>
        <h3 style={{"display": "inline-block","fontSize": "20px","margin": 0,"lineHeight": "56px"}}>Total {collection.questions.length} questions</h3>
        <div className="float-right" style={{"lineHeight": "56px"}}>
          <div style={{"lineHeight": "36px", "display": "inline-block"}}>
            <RaisedButton
              onClick={this.stepChangeHandle.bind(this, 0)}
              label="Change Concept"
              primary={true}
              icon={<i style={{"color": "white"}} className="fa fa-angle-left" />}
            />
          </div>
          <div style={{"lineHeight": "36px", "display": "inline-block"}}>
            <RaisedButton
              onClick={this.stepChangeHandle.bind(this, 2)}
              label="Preview & Submit"
              labelPosition="before"
              secondary={true}
              icon={<i style={{"color": "white"}} className="fa fa-angle-right" />}
            />
          </div>
        </div>
      </div>
    );
    else if (step === 2) return (
      <div className="text-right" style={{"marginTop": "10px"}}>
        <RaisedButton
          onClick={this.stepChangeHandle.bind(this, 1)}
          label="Edit Questions"
          secondary={true}
          icon={<i style={{"color": "white"}} className="fa fa-angle-left" />}
        />
        <RaisedButton
          onClick={this.submitCollection}
          label="Submit"
          primary={true}
          icon={<i style={{"color": "white"}} className="fa fa-check" />}
        />
      </div>
    )
  },

  getInitialState: function() {
    return {
       reviewTaskData: {
         contentInfo: {
           questions: []
         }
       },
       collection: {
         questions: []
       },
       currentStepIndex: 1
    };
  },

  componentWillMount: function() {

  },

  componentWillReceiveProps: function(nextProps) {

  },

  render: function() {
    var _this = this,
        taskData = this.state.reviewTaskData,
        collection = this.state.collection,
        currentStep = this.state.currentStepIndex;
    console.log('concepts', this.state.concepts)
    return (
      <div className="review-collection-container">
        {this.state.openConfirm && this.confirmable}
        <div className="content-toolbar">
          <h3>Revise Collection</h3>
          <div className="btn-holder">
            <RaisedButton
              onClick={this.discardCollection.bind(this, null)}
              target="_blank"
              label="Discard Changes"
              backgroundColor="#EF5350"
              labelStyle={{color: "white"}}
              icon={<i style={{"color": "white"}} className="fa fa-remove" />}
            />
            <RaisedButton
              onClick={this.saveCollection.bind(this, null)}
              target="_blank"
              label="Save Changes"
              primary={true}
              icon={<i style={{"color": "white"}} className="fa fa-save" />}
            />
          </div>
        </div>
        <div className="review-collection row">
          <div className="col-md-8 editor">
            <div className="content-step small">
            {
              steps.map((step, index)=>{
                return (
                  <div className={"step " + (_this.state.currentStepIndex === index ? 'active':'')} key={index} onClick={_this.navigateStep.bind(_this, step)}>{step.title}</div>
                )
              })
            }
            </div>
            {_this.renderHeaderActionBaseOnStep()}
          </div>
          <div className="col-md-4">
            <div className="review-title txt-secondary text-center" style={{lineHeight: "44px",fontSize: "19px",background: "#f2f2f2"}}><b>Reviews</b></div>
          </div>
          <div className="editor">
            {
              currentStep === 0 &&
              <div>
                <div className="content-play col-md-8">
                  <EditorStep1
                    collection={collection}
                    onConceptChange={_this.updateConceptChange}
                    onStepChange={_this.stepChangeHandle.bind(_this, 1)}
                    updateConceptLeafMapping={_this.updateConceptLeafMapping}
                    updateConcepts={_this.updateConcepts}
                    onSubjectChange={_this.updateSubject}
                  />
                </div>
                <div className="col-md-4 review-content">
                  <p className="margin-top-15">Go to Step 2 to see reviews</p>
                </div>
              </div>
            }
            {
              currentStep === 1 && taskData.contentInfo.questions.length > 0 && (
                <div>
                  {
                    taskData.contentInfo.questions.map(function(question, index) {
                      return (
                        <div key={index}>
                          <div className="content-play col-md-8">
                            <QuestionContainer subject={_this.state.subject}  key={index} question={question} questionIndex={index} onQuestionRemoved={_this.removeQuestion.bind(null, question)}/>
                          </div>
                          <div className="review-content col-md-4">
                            <ReviewQuestion
                              question={question}
                              reviewTaskData={taskData}
                              taskMode='revise'
                            />
                            {
                              (!question.kquestion.reviewTasks || question.kquestion.reviewTasks.length<=0) &&
                              <p className="txt-danger" style={{fontSize: "16px", fontWeight: 500}}>There are no reviews for this question</p>
                            }
                          </div>
                        </div>
                      )
                    })
                  }
                  <div className="col-md-8">
                    <RaisedButton
                      onClick={_this.addQuestion}
                      label="Add Question"
                      secondary={true}
                      icon={<i style={{"color": "white"}} className="fa fa-plus" />}
                    />
                  </div>
                </div>
              )
            }
            {
              currentStep === 2 && taskData.contentInfo.questions.length > 0 && (
              taskData.contentInfo.questions.map(function(question, index) {
                return (
                  <div key={index}>
                    <div className="content-play col-md-8">
                      <QuestionContent   questions={[question]} questionIndex={index} conceptLeafMapping={_this.state.conceptsMap}/>
                    </div>
                    <div className="review-content col-md-4">
                      <ReviewQuestion
                        question={question}
                        reviewTaskData={taskData}
                        taskMode='revise'
                      />
                      {
                        (!question.kquestion.reviewTasks || question.kquestion.reviewTasks.length<=0) &&
                        <p className="txt-danger" style={{fontSize: "16px", fontWeight: 500}}>There are no reviews for this question</p>
                      }
                    </div>
                  </div>
                )
              })
              )
            }
          </div>
        </div>
        {
          taskData.contentInfo._id &&
          <CollectionCommentList
            reviewTaskData={taskData}
            taskMode='revise'
          />
        }
      </div>
    );
  },


  componentDidMount: function() {
    var _this = this;
    this.retrieveCollectionWithTask(function() {
       _this.retrieveConceptsMap(_this.state.taskData, function() {
        _this.retrieveAllConcepts(function() {
          var collection = _this.state.collection;
          if (collection && collection._id && collection.questions && collection.questions.length > 0) {
          var concept = collection.questions[0].kquestion.concepts[0];
          var activeConcepts = _this.rebuildConceptData(concept);
          var concepts = _this.state.concepts;
          concepts.activeChildren = activeConcepts;
          console.log(concepts)
            _this.setState({
              concepts: concepts,
              subject: concepts.activeChildren._id
            })
          } 
        })
       })
      //this.state.reviewData, function(){
      //   _this.setState({isLoading: false})
      //   var collection = _this.state.collection;
      //   if (collection && collection._id && collection.questions && collection.questions.length > 0) {
      //   var concept = collection.questions[0].kquestion.concepts[0];
      //   var activeConcepts = _this.rebuildConceptData(concept);
      //   var concepts = _this.state.concepts;
      //   concepts.activeChildren = activeConcepts;
      //   _this.setState({
      //     concepts: concepts
      //   })
      // }
      // })
    });
  },
  componentDidUpdate: function () {
    var _this = this;
    window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub, ReactDOM.findDOMNode(_this)]);
  }
});

module.exports = ReviseCollection;



/** WEBPACK FOOTER **
 ** ./src/components/Tasks/Revise/ReviseCollection.js
 **/